












import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import ECharts from 'vue-echarts'
import registerTheme from './registerTheme'
import {PatientInMachineData} from '../../api/realTime'

@Component({
  components:{ECharts}
})
export default class extends AbpBase{
    @Prop({type:Object}) data:any;
    
    option = {

    }
    @Watch('data')
    watchData(val:any){
        this.getData()
    }
    async getData(){
        let res = await PatientInMachineData({
            id:this.data.id,
            tenantId:this.data.tenantId,
            itemCodes:this.data.dialysisInMachineData.map((item:any)=>{
                return {
                    item_Code:item.itemCode,
                    item_Name:item.itemName,
                }
            })
        })
        console.log(res)
        this.loadCharts(res.data)
    }
    created() {
        this.getData()
        ECharts.registerTheme('ECharts',registerTheme)
        setInterval(()=> {
            // this.loadCharts()
        }, 5000);//设置定时器，每一分钟就刷新一次数据
    }
    loadCharts(data:any){
        var rs:any = data;
        console.log(rs)
        var timeData = new Array();
        for (var i = 0; i < rs[1].itemDetail.length; i++) {
            timeData.push(rs[1].itemDetail[i].dateTime);
        }
        var mytitle = new Array();
        var leftValue;
        var topValue = [50, 50, 400, 400, 750, 750, 1100, 1100, 1450, 1450];
        for (var j = 0; j < rs.length; j++) {
            if (j % 2 == 0) {
                leftValue = '6%';
            } else {
                leftValue = '54%';
            }
            if(j>1){
                mytitle.push({
                    text:j==2?'血压监测':rs[j].itemName,
                    top: topValue[j-2],
                    left: leftValue,
                    textStyle: {
                        fontSize: 16,
                        fontFamily: 'MicrosoftYaHei',
                        fontWeight: 'normal'
                    },
                })
            }
        }
        this.option = {
            color: ['#60edc0', '#3fed94', '#683fed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed', '#3fe8ed'],//每条折线的颜色
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    animation: true
                },
                formatter: function (params, ticket, callback) {
                    var res = ""
                    for (i = 0; i < params.length; i++) {
                        //x轴名称
                        var name = params[i].name;
                        //图表title名称
                        var seriesName = params[i].seriesName;
                        //值
                        var value = params[i].value;
                        res += seriesName + '：' + value + '&nbsp;&nbsp;&nbsp;' + name + '<br />';
                    }
                    return res;
                }
            },
            axisPointer: {
                link: {xAxisIndex: 'all'}
            },
            dataZoom: [
                {
                    borderColor: '#3276B3',
                    dataBackground: {
                        lineStyle: {
                            color: '#31aaff'
                        }
                    },
                    fillerColor: 'rgba(118,174,241,0.8)',
                    textStyle: {
                        color: '#fff'
                    },
                    top: '14',
                    right: '60',
                    height: '20',
                    width: '40%',
                    show: true,
                    realtime: true,
                    start: 0,//时间轴是从哪里开始显示
                    end: 100,
                    xAxisIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8]
                }
            ],

            legend: [{
                data: ['收缩压', '舒张压', '心率'],
                x: '28%',
                top: '54',
                textStyle: {
                    color: '#fff'
                }
            }],
            title: mytitle,
            grid: [
                {
                    top: '100',
                    left: '10%',
                    height: '240',
                    width: '36%'
                }, {
                    top: '100',
                    left: '58%',
                    width: '36%',
                    height: '240'
                }, {
                    top: '450',
                    left: '10%',
                    height: '240',
                    width: '36%'
                }, {
                    top: '450',
                    left: '58%',
                    width: '36%',
                    height: '240'
                }, {
                    top: '800',
                    left: '10%',
                    height: '240',
                    width: '36%'
                }, {
                    top: '800',
                    left: '58%',
                    width: '36%',
                    height: '240'
                }, {
                    top: '1150',
                    left: '10%',
                    height: '240',
                    width: '36%'
                }, {
                    top: '1150',
                    left: '58%',
                    width: '36%',
                    height: '240'
                }, {
                    top: '1510',
                    left: '10%',
                    height: '240',
                    width: '36%'
                }
            ],
            xAxis: [
                {
                    gridIndex: 0,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,//表示从0开始
                        lineStyle: {}
                    },
                    data: timeData
                },
                {
                    gridIndex: 1,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 2,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 3,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 4,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 5,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 6,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 7,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }, {
                    gridIndex: 8,
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        onZero: true,
                        lineStyle: {}
                    },
                    data: timeData
                }
            ],
            yAxis: [
                {
                    gridIndex: 0,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 1,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 2,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 3,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 4,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 1;
                    },
                    max: function (value) {
                        return value.max + 1;
                    }
                },
                {
                    gridIndex: 5,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 6,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 5;
                    },
                    max: function (value) {
                        return value.max + 5;
                    }
                },
                {
                    gridIndex: 7,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 0.5;
                    },
                    max: function (value) {
                        return value.max + 0.5;
                    }
                },
                {
                    gridIndex: 8,
                    type: 'value',
                    axisLine: {
                        lineStyle: {}
                    },
                    min: function (value) {
                        return value.min - 1;
                    },
                    max: function (value) {
                        return value.max + 1;
                    }
                }
            ],
            series: [
                {
                    name: rs[0].itemName,
                    type: 'line',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbolSize: 8,//标识每个点的圆圈的大小
                    hoverAnimation: true,//指针悬浮时是否有动画
                    data: rs[0].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name:  rs[1].itemName,
                    type: 'line',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[1].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[2].itemName,
                    type: 'line',
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[2].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[3].itemName,
                    type: 'line',
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[3].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[4].itemName,
                    type: 'line',
                    xAxisIndex: 2,
                    yAxisIndex: 2,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[4].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[5].itemName,
                    type: 'line',
                    xAxisIndex: 3,
                    yAxisIndex: 3,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[5].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[6].itemName,
                    type: 'line',
                    xAxisIndex: 4,
                    yAxisIndex: 4,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[6].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[7].itemName,
                    type: 'line',
                    xAxisIndex: 5,
                    yAxisIndex: 5,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[7].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[8].itemName,
                    type: 'line',
                    xAxisIndex: 6,
                    yAxisIndex: 6,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[8].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[9].itemName,
                    type: 'line',
                    xAxisIndex: 7,
                    yAxisIndex: 7,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[9].itemDetail.map((v:any)=>{return v.itemValue})
                },
                {
                    name: rs[10].itemName,
                    type: 'line',
                    xAxisIndex: 8,
                    yAxisIndex: 8,
                    symbolSize: 8,
                    hoverAnimation: true,
                    data:  rs[10].itemDetail.map((v:any)=>{return v.itemValue})
                },
            ]
        };
    }
}
